// ─────────────────────────────────────────────────────────────────────────────
//  Контроль качества: общий язык цвета и подписей.
// ─────────────────────────────────────────────────────────────────────────────
//
// Один файл на раздел, чтобы карточка у контролёра и карточка у чертёжника
// говорили одинаково: «ждёт проверки» не может быть где-то синим, а где-то
// серым — иначе люди перестают доверять цвету и читают каждую строку.

export const QA_META = {
  '': {
    label: 'Без контроля', short: '—',
    accent: '#94a3b8', soft: '#f1f5f9', border: '#e2e8f0', text: '#475569',
  },
  pending: {
    label: 'Ждёт проверки', short: 'На проверке',
    accent: '#7b5cff', soft: '#f3f0ff', border: '#ddd6fe', text: '#4c1d95',
  },
  rework: {
    label: 'На доработке', short: 'Доработка',
    accent: '#dc2626', soft: '#fef2f2', border: '#fecaca', text: '#991b1b',
  },
  rework_accepted: {
    label: 'Дорабатывается', short: 'В работе',
    accent: '#f59e0b', soft: '#fffbeb', border: '#fde68a', text: '#92400e',
  },
  passed: {
    label: 'Проверку прошёл', short: 'Готово к выдаче',
    accent: '#16a34a', soft: '#f0fdf4', border: '#bbf7d0', text: '#166534',
  },
};

export const qaMeta = (state) => QA_META[state || ''] || QA_META[''];

export const SCOPES = [
  { key: 'pending',     label: 'Ждут проверки' },
  { key: 'rework',      label: 'На доработке' },
  { key: 'in_progress', label: 'Дорабатываются' },
  { key: 'done',        label: 'Проверенные' },
  { key: 'additional',  label: 'Допобмеры' },
  { key: 'all',         label: 'Все' },
];

export const fmtDate = (iso) => {
  if (!iso) return '';
  const d = new Date(String(iso).length <= 10 ? `${iso}T00:00:00` : iso);
  return isNaN(d) ? String(iso) : d.toLocaleDateString('ru-RU');
};

export const fmtDateTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d) ? String(iso) : d.toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  });
};

// «3 ч», «2 дн 4 ч» — сколько чертёж ждёт проверки.
export function fmtWaiting(hours) {
  const h = Number(hours || 0);
  if (!h || h < 0) return '';
  if (h < 1) return 'меньше часа';
  if (h < 24) return `${Math.round(h)} ч`;
  const d = Math.floor(h / 24);
  const rest = Math.round(h - d * 24);
  return rest ? `${d} дн ${rest} ч` : `${d} дн`;
}

export const fmtSize = (bytes) => {
  const b = Number(bytes || 0);
  if (!b) return '';
  if (b < 1024) return `${b} Б`;
  if (b < 1024 * 1024) return `${Math.round(b / 1024)} КБ`;
  return `${(b / 1024 / 1024).toFixed(1)} МБ`;
};

export const isImage = (mime, name) =>
  String(mime || '').startsWith('image/')
  || /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(String(name || ''));

// Ожидание красим: час — норма, сутки — уже стыдно.
export function waitingColor(hours) {
  const h = Number(hours || 0);
  if (h >= 24) return 'danger';
  if (h >= 8) return 'warning';
  return 'neutral';
}
